const colors = {
  snow: "white",
  coal: "#33353d",
  whiteSmoke: "#f7f7f8",
  lightGray: "rgba(242, 242, 242, 0.4)",
  grey: "rgb(244, 245, 247);",
  transparent: "rgba(0,0,0,0)",
  transparentWhite: "rgba(255,255,255,0.1)",
  semiTransparentWhite: "rgba(255,255,255, 0.5)",
  error: "rgba(200, 0, 0, 0.8)",
  success: "#16a085",
  overlayBlack: "rgba(0,0,0,0.4)",
  semiBlack: "rgba(0,0,0,0.5)",
  galleryBlack: "rgba(0,0,0,0.7)",
  cmmsBlue: "#208EFE",
  cmmsDarkBlue: "rgba(52, 57, 81, 0.847)",
  formWhite: "rgba(255,255,255,0.9)",
  selectLabel: "#F0F3F8",
  paleGrey: "#f0f3f9",
  blueGrey: "#9397ab",
  aquaMarine: "#00e2af",
  ligthishBlue: "#009BDA",
  coralPink: "#ff6a70",
  green: "#69B253"
};

export default colors;



// WEBPACK FOOTER //
// ./src/Themes/Colors.ts